import { render, staticRenderFns } from "./RegistrationRequestIdentityChecklistItem.vue?vue&type=template&id=0cc9ff0a&scoped=true"
import script from "./RegistrationRequestIdentityChecklistItem.vue?vue&type=script&lang=js"
export * from "./RegistrationRequestIdentityChecklistItem.vue?vue&type=script&lang=js"
import style0 from "./RegistrationRequestIdentityChecklistItem.vue?vue&type=style&index=0&id=0cc9ff0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9ff0a",
  null
  
)

export default component.exports